import {FC} from 'react';
import {ReactComponent as Candle1Icon} from '../../icons/candle.svg';
import {ReactComponent as Candle2Icon} from '../../icons/candle-2.svg';
import {ReactComponent as Candle3Icon} from '../../icons/candle-3.svg';
import {ReactComponent as Candle4Icon} from '../../icons/candle-4.svg';
import {ReactComponent as Candle5Icon} from '../../icons/candle-5.svg';
import {CandleType} from '../../enums/CandleType';

export type TProps = {
    type: string;
}

const candleIcons: Record<string, JSX.Element> = {
    [CandleType.Candle1]: <Candle1Icon/>,
    [CandleType.Candle2]: <Candle2Icon/>,
    [CandleType.Candle3]: <Candle3Icon/>,
    [CandleType.Candle4]: <Candle4Icon/>,
    [CandleType.Candle5]: <Candle5Icon/>,
};

const CandleIcon: FC<TProps> = ({type}) => {
    return candleIcons[type] ?? <Candle1Icon/>;
};

export default CandleIcon;
